type SidebarNavItemStyleProps = {
  color: string;
  bg: string;
  _hover: {
    color: string;
    bg: string;
  };
};

export function getSidebarNavItemStyleProps({
  isActive,
  disabled,
}: {
  isActive: boolean;
  disabled?: boolean;
}): SidebarNavItemStyleProps {
  const color = isActive ? 'fg.neutral.default' : 'fg.neutral.muted';
  const bg = isActive ? 'bg.neutral.muted' : 'transparent';

  return {
    color,
    bg,
    _hover: disabled
      ? { color, bg }
      : {
          color,
          bg: isActive ? 'bg.neutral.muted' : 'bg.neutral.hover',
        },
  };
}
